export default "__VITE_ASSET__1oDCrTc6__"